<section
  class="toggle-form"
  [ngClass]="{ active: isTrainingItemSliderOpen }"
>
  <div class="formwrap">
    <div class="Header">
      <h2>
        <b>{{trainingItemGroupSliderTitle}}</b>
      </h2>
      <p-button
      appPreventDoubleClick
        styleClass="p-button-text"
        id="trainingItemGroupSliderCloseButton"
        type="button"
        label="Close"
        (debounceClick)="closeSlider()"
      ></p-button>
    </div>
    <div class="general-container">
      <app-training-item-group-general-details></app-training-item-group-general-details>
    </div>
  </div>
</section>
